<template>
  <div>
    <div v-if="isGameOver">
      It's over!
      <button @click="reset">restart</button>
    </div>
    <div v-else class="music_containaer">
      <!-- 상단 정보 -->
      <div class="music_top">
        <div class="music_top_board">
          <div>TIME : {{ timeLimit }}</div>
          <div class="music_top_board_score">SCORE : {{ points }}</div>
          <div class="music_top_board_life">
            <font-awesome-icon
              icon="heart"
              v-for="i in life"
              :key="i"
              style="margin-left: 5px;"
            />
          </div>
        </div>
      </div>
      <!-- 중간 플레이버튼 -->
      <div class="music_mid">
        <v-progress-circular
          rotate="270"
          size="119"
          width="5"
          :value="progressValue"
          color="#9ae1ea"
        >
          <div class="music_mid_player">
            <div
              v-if="!playCheck"
              v-on:click="() => isPlaying()"
              class="music_mid_btn_on"
            >
              <font-awesome-icon icon="play" />
            </div>
            <div
              class="music_mid_btn_off"
              v-if="playCheck"
              v-on:click="() => isPlaying()"
            >
              <font-awesome-icon icon="headphones" />
            </div>
          </div>
        </v-progress-circular>
      </div>
      <!-- 사지선다 -->
      <div class="music_btm">
        <div
          class="music_btm_choice"
          v-for="music in randomMusics"
          :key="music.name"
          @click="() => onSelect(music.name)"
        >
          <div class="music_btm_choice_text">
            {{ music.name }}
          </div>
          <div class="music_btm_space" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sampleSize from "lodash.samplesize";
import random from "lodash.random";
import shuffle from "lodash.shuffle";

const TIME_LIMIT = 120;
const MAX_LIFE = 3;

export default {
  name: "RandomMusic",
  methods: {
    onTimesUp() {
      clearInterval(this.timerInterval);
      this.replayClick = false;
    },
    play() {
      if (this.player) {
        this.player.play();
      }
    },
    onSelect(userAnswer) {
      const answer = this.randomMusics[this.answer];

      if (answer.name !== userAnswer) this.life--;
      if (!this.life) this.isGameOver = true;

      this.points += 10;
      this.musics = shuffle(this.musics);
      this.answer = random(0, 3);
      this.loadNewMusic();
    },
    reset() {
      this.isGameOver = false;
      this.points = 0;
      this.musics = shuffle(this.musics);
      this.answer = random(0, 3);
      this.life = MAX_LIFE;
      this.timeLimit = TIME_LIMIT;
    },
    loadNewMusic() {
      if (this.player) {
        this.player.pause();
        this.player.src = this.randomMusics[this.answer].src;
        this.player.load();
      }
    },
    isPlaying() {
      if (this.playCheck) {
        this.playCheck = false;
        this.progressValue = 0;
        clearInterval(this.progressInterval);
      } else {
        this.playCheck = true;
        this.progressValue = 0;

        const period = 2000; // 2초
        const interval = 250; // ms

        this.progressInterval = setInterval(() => {
          if (this.progressValue >= 100) return;
          this.progressValue += ((interval + 100) / period) * 100;
        }, interval);
      }
    }
  },
  watch: {
    isGameOver(gameOver) {
      if (gameOver) {
        this.loadNewMusic();
      }
    },
    timeLimit: {
      handler(value) {
        if (value > 0) {
          this.timer = setTimeout(() => {
            this.timeLimit--;
          }, 1000);
        } else {
          this.isGameOver = true;
        }
      }
    }
  },
  async mounted() {
    this.player = this.$refs.audio;

    const musics = await fetch(
      "https://s3.ap-northeast-2.amazonaws.com/s.spready.net/musics.json"
    ).then(res => res.json());
    this.musics = musics;

    clearTimeout(this.timer);
    // 게임 시작하면서 countdown 시작
    this.timeLimit--;
  },
  beforeDestroy() {
    clearInterval(this.progressInterval);
  },
  computed: {
    randomMusics() {
      return sampleSize(this.musics, 4);
    }
  },
  data() {
    return {
      replayClick: false,
      timerInterval: null,
      timeLimit: 120,
      timePassed: 0,
      player: null,
      isGameOver: false,
      points: 0,
      answer: random(0, 3),
      currentMusic: null,
      musics: [],
      life: MAX_LIFE,
      playCheck: false,
      // progress bar
      progressInterval: {},
      progressValue: 0
    };
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Do+Hyeon&display=swap");

:root {
  --sky-blue: #36c4d5;
}

.music_containaer {
  width: 320px;
  justify-content: center;
  align-items: center;
  text-align: center;
  display: flex;
  flex-direction: column;
  font-family: "Do Hyeon", cursive;
}
/* 상중하로 분리 ===============================================*/
.music_top {
  width: 100%;
  height: 50px;
  background: #2f3847;
}
.music_mid {
  width: 100%;
  height: 120px;
  background: url("../assets/musics/music_bg.png") no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.music_btm {
  width: 100%;
  height: 200px;
  padding-top: 10px;
  background: var(--sky-blue);
}
/* 상단 부분 ===============================================*/
.music_top_board {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 1rem;
  color: white;
}
.music_top_board_score {
  white-space: nowrap;
}
.music_top_board_life {
  color: var(--sky-blue);
  min-width: 63px;
  display: flex;
  justify-content: flex-end;
}
.music_top_bar_section {
  max-width: 57rem;
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
}
.music_top_progressbar {
  width: 85%;
  height: 1px;
  align-items: center;
}
/* 중간 부분 ===============================================*/
.music_mid_player {
  width: 110px;
  height: 110px;
  background: white;
  border-radius: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.music_mid_btn_on {
  width: 100%;
  font-size: 2.5rem;
  color: var(--sky-blue);
  margin-left: 10px;
}
.music_mid_btn_off {
  width: 100%;
  font-size: 2.5rem;
  color: var(--sky-blue);
}
/* 사지선다 부분 ===============================================*/
.music_btm_choice {
  padding: 0 16px;
  display: block;
  cursor: pointer;
}
.music_btm_choice:hover > .music_btm_choice_text {
  opacity: 0.5;
}
.music_btm_choice_text {
  color: white;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin: 10px 0;
  font-size: 1rem;
  display: flex;
  align-items: center;
}
.music_btm_space {
  width: 100%;
  height: 1px;
  background: var(--sky-blue);
  justify-content: center;
  text-align: center;
  align-items: center;
}

/** 재생 아이콘 중간 정렬 */
.music_mid_btn_on > .svg-inline--fa.fa-play {
  margin-right: calc(28% + 3px);
}

.music_mid_btn_off > .svg-inline--fa.fa-headphones {
  margin-right: calc(28% + 3px);
}
</style>
